import { Component, Vue } from 'vue-property-decorator'

@Component
export class CommonMixin extends Vue {
  selectFilter(input, option) {
    return ~option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase())
  }
}
